// this is an autogenerated file from App/Account/Content/Settings/Content/TreatmentAutomations/AutomationsList/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_TreatmentAutomations_AutomationsList_Content($filters: events_events_bool_exp!) {
  events_events(
    where: $filters
    order_by: { name: asc, app_id: desc_nulls_first }
  ) {
    id
    name
    data
    type
    status
    delay
    updated_at
    automation_type
    organization_id
    app_id
    actions {
      id
      type
    }
  }
}

`